import React from "react";
import { useAppEventGameDetailSelector } from "src/_common/hooks/selectors/eventSelector";

const QuestionWithOptions = ({ currentQuestionIndex, openOptionSelectionModal }: any) => {
  const eventGameDetailsSelector = useAppEventGameDetailSelector();

  return (
    <>
      <p className="mb-4 text-blue-cstm">Guess the probability and win points!</p>
      {eventGameDetailsSelector?.events?.questions_dtls?.length > 0 ? (
        <>
          <h3 className="section-heading">
            {eventGameDetailsSelector?.events?.questions_dtls[currentQuestionIndex]?.question}
          </h3>
          <div className="guess-points-list-panel pt-2">
            {eventGameDetailsSelector?.events?.questions_dtls[currentQuestionIndex]?.answer_cont_dtls?.length > 0
              ? eventGameDetailsSelector?.events?.questions_dtls[currentQuestionIndex]?.answer_cont_dtls?.map(
                  (option: any) => (
                    <div
                      className={
                        "guess-points-list-block " +
                        (eventGameDetailsSelector?.events?.user_answers?.find(
                          (x: any) => x?.question_id == option?.question_id && x?.answer_id == option?.id
                        )
                          ? "active"
                          : "")
                      }
                      onClick={(e) => openOptionSelectionModal(e, option)}
                    >
                      {eventGameDetailsSelector?.events?.questions_dtls[currentQuestionIndex]?.question_type == 2 ? (
                        <div className="d-flex gap-3 align-items-center">
                          <div className="winner-avatar">
                            <img
                              src={
                                option?.contestant_avatar?.id != 0
                                  ? option?.contestant_avatar?.original
                                  : option?.contestant_dtls?.avatar?.id != 0
                                  ? option?.contestant_dtls?.avatar?.original
                                  : "/images/no-image.png"
                              }
                              style={{ width: "100%" }}
                            />
                          </div>
                          <div className="winner-content">
                            <h4>{option?.answer_contestant || option?.contestant_dtls?.name}</h4>
                          </div>
                        </div>
                      ) : (
                        <h5>{option?.answer_contestant}</h5>
                      )}
                      <h6>{option?.point || 0} Points</h6>
                    </div>
                  )
                )
              : null}
          </div>
        </>
      ) : (
        <div className="guess-points-list-block">
          <h5>No questions available</h5>
        </div>
      )}
    </>
  );
};

export default QuestionWithOptions;
